export default __webpack_public_path__ + "navigation-examples-advanced-1200-e267f0b33ad2da74b419597cf9eab388.png";